import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const heroWords = ['高效', '安全', '智能', '可靠'];

export default function HeroSection() {
  const [currentWord, setCurrentWord] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % heroWords.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20abstract%20geometric%20design%20with%20warm%20golden%20and%20cream%20gradients%2C%20smooth%20flowing%20shapes%2C%20minimalist%20elegant%20background%2C%20soft%20ambient%20lighting%2C%20luxurious%20warm%20atmosphere%2C%20no%20text%2C%20abstract%20artistic%20composition%20with%20organic%20curves%20and%20geometric%20elements%20in%20warm%20earth%20tones&width=1800&height=900&seq=jmtt-hero-bg&orientation=landscape"
        alt="JMTT平台背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-white/90 text-sm font-medium">JMTT v4.2 全新上线</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
          值得信赖的
          <span className="relative inline-block mx-2">
            <span className="relative z-10 text-primary-400 transition-all duration-500">
              {heroWords[currentWord]}
            </span>
            <span className="absolute bottom-1 left-0 right-0 h-3 bg-primary-500/30 rounded-full -z-0"></span>
          </span>
          优质平台
        </h1>

        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          JMTT为全球用户提供全面的数字化服务与解决方案，涵盖数据管理、交易处理、智能营销与协作办公。立即加入JMTT，探索无限可能。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            立即注册
          </Link>
          <Link
            to="/categories"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm hover:bg-white/25 text-white font-medium text-sm rounded-lg border border-white/30 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { value: '500万+', label: '活跃用户' },
            { value: '99.9%', label: '服务可用率' },
            { value: '200+', label: '覆盖国家' },
            { value: '10亿+', label: '处理交易' }
          ].map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
              <div className="text-white/50 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}